import { render } from "./detalle_oferta_laboral_AS.vue?vue&type=template&id=467dc5d8&scoped=true"
import script from "./detalle_oferta_laboral_AS.vue?vue&type=script&lang=js"
export * from "./detalle_oferta_laboral_AS.vue?vue&type=script&lang=js"

import "./styles/shared_AS.css?vue&type=style&index=0&id=467dc5d8&scoped=true&lang=css&external"
import "./styles/detalle_oferta_laboral_AS.css?vue&type=style&index=1&id=467dc5d8&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467dc5d8"]])

export default __exports__